import dayjs from 'dayjs';
import api from '../../config/api';
import { saveBlob, blobErrorBody } from '../downloadFile';

/**
 * Término de contrato y aviso de vencimiento de plazo (PLAN_ERP.md §15,
 * 2026-10-19): utilidades compartidas por el detalle y el listado de contratos.
 * Fechas en ISO YYYY-MM-DD (convención "Fechas"); se muestran con formatDate.
 */

// Respaldo si el catálogo aún no carga (el backend manda los mismos en `meta`)
export const EXPIRATION_NOTICE_CAUSE_CODE = '159-4';
export const SETTLEMENT_DEFAULT_DAYS = 12;

export const todayIso = () => dayjs().format('YYYY-MM-DD');

export const addDaysIso = (iso, days) =>
  iso ? dayjs(iso).add(days, 'day').format('YYYY-MM-DD') : '';

/** Días desde hoy hasta la fecha (negativo si ya pasó) */
export const daysUntil = (iso) => dayjs(iso).startOf('day').diff(dayjs().startOf('day'), 'day');

/** Razones traducidas de lo que falta para el aviso ("falta la dirección…; …") */
export const missingReasons = (t, missing = []) =>
  missing.map((code) => t(`erp.contracts.termination.missing.${code}`)).join('; ');

/**
 * Descarga el PDF de avisos (uno o varios contratos con término 159-4).
 * Si a alguno le faltan datos el backend responde 422 NOTICE_DATA_MISSING sin
 * PDF: con responseType blob el cuerpo llega como Blob, así que se lee el JSON
 * y se lanza un error con `issues` y `readyContractIds`.
 */
export const downloadTerminationNotices = async ({ organization, authToken, contractIds, fileName }) => {
  let response;
  try {
    response = await api.post(
      '/erp/contracts/termination-notices',
      { organizationId: organization, contractIds },
      { headers: { Authorization: `Bearer ${authToken}` }, responseType: 'blob' }
    );
  } catch (err) {
    const data = err.response?.status === 422 ? await blobErrorBody(err) : null;
    if (data?.code === 'NOTICE_DATA_MISSING') {
      const missingError = new Error('NOTICE_DATA_MISSING');
      missingError.code = data.code;
      missingError.issues = data.issues || [];
      missingError.readyContractIds = data.readyContractIds || [];
      throw missingError;
    }
    throw err;
  }
  saveBlob(response.data, fileName, 'application/pdf');
};
